import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ReportsService {
  reportsUrl: string = 'api/Se7etak';

  constructor(
    private http: HttpClient
  ) { }

  getTopLabsStats(params): Observable<any> {
    return this.http.get(`${ this.reportsUrl }/TopLabsStats`, {
      params
    });
  }

  getTpaRequests(params): Observable<any> {
    return this.http.get(`${ this.reportsUrl }/TotalTpaApprovalsAndReimbursements`, {
      params
    });
  }
}
